// assets/js/components/dropdown.js
export class DropdownMenu {
    constructor(toggleId, menuId) {
        this.toggleElement = document.getElementById(toggleId);
        this.menuElement = document.getElementById(menuId);
        this.init();
    }

    init() {
        if (!this.toggleElement || !this.menuElement) return;

        this.checkbox = this.toggleElement.querySelector('input[type="checkbox"]');
        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener('click', (e) => this.handleClickOutside(e));
        document.addEventListener('keydown', (e) => this.handleEscape(e));
    }

    handleClickOutside(event) {
        if (this.checkbox?.checked &&
            !this.toggleElement.contains(event.target) &&
            !this.menuElement.contains(event.target)) {
            this.closeMenu();
        }
    }

    handleEscape(event) {
        if (event.key === 'Escape' && this.checkbox?.checked) {
            this.closeMenu();
        }
    }

    closeMenu() {
        this.checkbox.checked = false;
        this.checkbox.dispatchEvent(new Event('change'));
    }
}